// Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

// Store
const nacional = new vapi({
    namespaced: true,
    baseURL: `${process.env.VUE_APP_REST}/api/nacional`,
    state: {
        planesnacionales: [],
        plannacional: [],
        nacionales: [],
        nacionalelemento: null,
        planesnacionalessectoriales: [],
        archivo: "",
        imagen: ""
    }
}).get({
    action: "get_nacionales",
    onSuccess: (state, payload) => {
        state.nacionales = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
        state.nacionales = []
    }
}).get({
    action: "get_vistanacional",
    path: function () {
        return `/vistaciudadano/`;
    },
    onSuccess: (state, payload) => {
        state.planesnacionales = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_plannacional",
    path: function (obj) {
        return `/vistaciudadano/${obj.idnacional}`;
    },
    onSuccess: (state, payload) => {
        state.plannacional = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
})
.get({
    action: "get_listapns",
    path: function () {
        return `/ListaPNS/`;
    },
    onSuccess: (state, payload) => {
        state.planesnacionalessectoriales = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_nacional",
    path: function (obj) {
        return `${obj.idnacional}`
    },
    onSuccess: (state, payload) => {
        state.nacionalelemento = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_nacionalarchivo",
    path: function (obj) {
        return `archivo/${obj.idnacional}`
    },
    onSuccess: (state, payload) => {
        state.archivo = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_nacionalimagen",
    path: function (obj) {
        return `imagen/${obj.idnacional}`
    },
    onSuccess: (state, payload) => {
        state.imagen = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).get({
    action: "get_nacionalbyname",
    path: function (obj) {
        return `nacionalpornombre/${obj.nombre}`;
    },
    onSuccess: (state, payload) => {
        state.planesnacionales = payload.data;
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).post({
    action: "post_nacional",
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).put({
    action: "put_nacional",
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).delete({
    action: "delete_nacional",
    path: function (obj) {
        return `/${obj.idnacional}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

nacional.getters = {
    gnacionales: state => {
        return state.nacionales
    },
    gnacional: state => {
        return state.nacionalelemento
    },
    gvistanacional: state => {
        return state.planesnacionales
    },
    gplannacional: state => {
        return state.plannacional
    },
    gpns: state => {
        return state.planesnacionalessectoriales
    },
    gnacionalarchivo: state => {
        return state.archivo
    },
    gnacionalimagen: state => {
        return state.imagen
    }
}
export default nacional;
